import { render, staticRenderFns } from "./01-OceanFrontAnalysis.md?vue&type=template&id=178d8719&"
import script from "./01-OceanFrontAnalysis.md?vue&type=script&lang=js&"
export * from "./01-OceanFrontAnalysis.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports